// --- Only include code that is used on every page here ---
// Keeping file as-is for when we need it

document.addEventListener(
  'DOMContentLoaded',
  () => {
    // no-op
  },
  false
)
